// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles-module__panel___30Zs8","header":"styles-module__header___2shC8","body":"styles-module__body___1zZXw"};